var map = {
	"./arrow-left-large.svg": 4511,
	"./arrow-right-large.svg": 6330,
	"./arrow-right.svg": 2748,
	"./arrow-top.svg": 7019,
	"./check.svg": 2782,
	"./clock.svg": 4876,
	"./close.svg": 7066,
	"./copy-link.svg": 6986,
	"./difficulty-level.svg": 4028,
	"./list-view-one-column.svg": 1594,
	"./list-view-two-columns.svg": 7643,
	"./menu-close.svg": 2924,
	"./menu.svg": 5775,
	"./print.svg": 8527,
	"./search.svg": 7286,
	"./star-empty.svg": 3818,
	"./star-full.svg": 3964,
	"./toggle.svg": 2374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9477;